import { render, staticRenderFns } from "./BasicButton.vue?vue&type=template&id=6f2d04cd"
import script from "./BasicButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BasicButton.vue?vue&type=style&index=0&id=6f2d04cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports